export default __webpack_public_path__ + "static/media/Sword of the Yellow Hand.f8ca061e.jpg";